export default __webpack_public_path__ + "static/media/idaho.7d5cc3ee.jpg";